// src/context/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { getSession, setSession, clearSession } from '../services/api';

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(getSession);   // hydrate from localStorage
  const [ready, setReady]     = useState(false);

  useEffect(() => {
    // If session exists in localStorage, trust it immediately.
    // No separate "me" call needed — your PHP has no /me endpoint.
    setReady(true);
  }, []);

  const login = (userData) => {
    setSession(userData);
    setUser(userData);
  };

  const logout = () => {
    clearSession();
    setUser(null);
  };

  if (!ready) return null; // wait for hydration before rendering anything

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

// Role constants matching your ryts field
export const ROLES = {
  ADMIN   : '1',
  SALES   : '2',
  FINANCE : '3',
  MANAGER : '4',
};

export const ROLE_LABELS = {
  '1': 'Admin',
  '2': 'Sales Rep',
  '3': 'Finance',
  '4': 'Manager',
};
